import styled from 'styled-components'

export const ContentFilters = styled.div`
  overflow: auto;
  white-space: nowrap;
  margin-bottom: 24px;
`
